
(function() {
  var result = { translations: { "hi": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0938\u0947\u0915\u0902\u0921", "minutes": "{{ minutes }} \u092E\u093F\u0928\u091F", "hours": "{{ hours }} \u0918\u0902\u091F\u093E", "hoursAndMinutes": "{{ hours }} \u0918\u0902\u091F\u093E {{ minutes }} \u092E\u093F\u0928\u091F", "days": "{{ days }} \u0926\u093F\u0928", "shortForm": { "seconds": "{{ seconds }}\u0938\u0947", "minutes": "{{ minutes }}\u092E\u093F", "hours": "{{ hours }}\u0918\u0902", "days": "{{ days }}\u0926\u093F", "hoursAndMinutes": "{{ hours }}\u0918\u0902 {{ minutes }}\u092E\u093F" } }, "dateTime": { "quarterAndYear": "\u0915\u094D\u0935\u093E{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "hi": "static-7.1085"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1085",
    "ar-eg": "static-7.1085",
    "bg": "static-7.1085",
    "bn": "static-7.1085",
    "ca-es": "static-7.1085",
    "cs": "static-7.1085",
    "da": "static-7.1085",
    "de": "static-7.1085",
    "el": "static-7.1085",
    "en-gb": "static-7.1085",
    "en": "static-7.1085",
    "es-mx": "static-7.1085",
    "es": "static-7.1085",
    "et": "static-7.1085",
    "fi": "static-7.1085",
    "fr-ca": "static-7.1085",
    "fr": "static-7.1085",
    "he-il": "static-7.1085",
    "hi": "static-7.1085",
    "hr": "static-7.1085",
    "hu": "static-7.1085",
    "id": "static-7.1085",
    "it": "static-7.1085",
    "ja": "static-7.1085",
    "ko": "static-7.1085",
    "lt": "static-7.1085",
    "ms": "static-7.1085",
    "nl": "static-7.1085",
    "no": "static-7.1085",
    "pl": "static-7.1085",
    "pt-br": "static-7.1085",
    "pt-pt": "static-7.1085",
    "ro": "static-7.1085",
    "ru": "static-7.1085",
    "sk": "static-7.1085",
    "sl": "static-7.1085",
    "sv": "static-7.1085",
    "th": "static-7.1085",
    "tl": "static-7.1085",
    "tr": "static-7.1085",
    "uk": "static-7.1085",
    "vi": "static-7.1085",
    "x-pseudo": "static-7.1085",
    "zh-cn": "static-7.1085",
    "zh-hk": "static-7.1085",
    "zh-tw": "static-7.1085"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hi', {version: 'static-7.1085'}); }
})();


